import { takeEvery, select, put } from 'redux-saga/effects';
// action types
import {
  SUBMIT_RISK,
  SUBMIT_SATISFACTION,
  SUBMIT_DAILY_CHECK,
} from '../reducers/recovery';
// actions
import { updateProgress } from '../reducers/auth';
import { openModal } from '../reducers/modal';

/* worker-saga */
function* onRiskSubmit({ payload }) {
  yield put(updateProgress(payload));

  const shouldOpenSatisfaction = yield select(
    state => !state.auth.user.progress.satisfaction
  );

  if (shouldOpenSatisfaction) {
    yield put(
      openModal('CHECK_IN', {
        type: 'monthly',
      })
    );
  }
}

function* onSatisfactionSubmit({ payload }) {
  yield put(updateProgress(payload));
}

function* onDailySubmit({ payload: { meta } }) {
  yield put(updateProgress(meta));
}

/* watcher-saga */
function* watchRecoveryActions() {
  yield takeEvery(`${SUBMIT_RISK}_SUCCESS`, onRiskSubmit);
  yield takeEvery(`${SUBMIT_SATISFACTION}_SUCCESS`, onSatisfactionSubmit);
  yield takeEvery(`${SUBMIT_DAILY_CHECK}_SUCCESS`, onDailySubmit);
}

export default watchRecoveryActions;



// WEBPACK FOOTER //
// ./src/redux/sagas/recovery.js